var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoomIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.88,
    height: 12.388,
    viewBox: "0 0 13.88 12.388",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1268",
    "data-name": "Group 1268",
    transform: "translate(0.375 0.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5089",
    "data-name": "Path 5089",
    d: "M109.631,422.872H96.5l1.253-5.372h10.624Z",
    transform: "translate(-96.5 -414.217)",
    fill: "none",
    stroke: "#29a19c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    width: 13.13,
    height: 1.791,
    transform: "translate(0 8.654)",
    fill: "none",
    stroke: "#29a19c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3507",
    "data-name": "Line 3507",
    y2: 1.194,
    transform: "translate(0.597 10.445)",
    fill: "none",
    stroke: "#29a19c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3508",
    "data-name": "Line 3508",
    y2: 1.194,
    transform: "translate(12.534 10.445)",
    fill: "none",
    stroke: "#29a19c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5090",
    "data-name": "Path 5090",
    d: "M103.872,415.283H98.5v-1.015A2.267,2.267,0,0,1,100.768,412h.836a2.267,2.267,0,0,1,2.268,2.268Z",
    transform: "translate(-97.306 -412)",
    fill: "none",
    stroke: "#29a19c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5091",
    "data-name": "Path 5091",
    d: "M112.872,415.283H107.5v-1.015A2.267,2.267,0,0,1,109.768,412h.836a2.267,2.267,0,0,1,2.268,2.268Z",
    transform: "translate(-100.935 -412)",
    fill: "none",
    stroke: "#29a19c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.75
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomIcon);
export default __webpack_public_path__ + "static/media/RoomIcon.b4236aef114f8c9659d05fbae996f3b4.svg";
export { ForwardRef as ReactComponent };